import { Component, ChangeDetectionStrategy, ViewEncapsulation, Input, Inject, HostListener } from '@angular/core';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';

import { TripTypes } from '@app/entities/trip-types';
import { IS_BROWSER } from '@app/modules/core/tokens/app.tokens';
import { FlightType } from '@search-bar/entities/flight-type';
import { BaseSearchBarFacade } from '@app/modules/shared/base-search-bar/base-search-bar-facade';
import { AutocompletePlace } from '@app/modules/shared/base-search-bar/entities/autocomplete';
import { CalendarInputsAbstract } from '@shared/base-search-bar/components/calendar/abstract/calendar-inputs.abstract';
import { SearchType } from '@app/modules/search-bar/entities/search-type';
import { isByHours } from '@hotels/hotel-search/componenets/byhours-search/mappers/byhours.mapper';

@Component({
  selector: 'app-calendar-inputs',
  templateUrl: './calendar-inputs.component.html',
  styleUrls: ['./calendar-inputs.component.sass'],
  encapsulation: ViewEncapsulation.ShadowDom,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})

export class CalendarInputsComponent extends CalendarInputsAbstract {

  @Input() isOneWayTrip: boolean = false;
  @Input() departureSelectionDisabled: boolean = false;
  @Input() set exchangeTripType(type: TripTypes) {
    this._exchangeTripType = type ? type : TripTypes.DEPARTURE;
  }

  public showFlightOptionSelection: boolean = false;
  public activeOption: string;
  public eventPath: BehaviorSubject<EventTarget[]> = new BehaviorSubject<EventTarget[]>([]);
  public arrivalPlace: AutocompletePlace;
  public departurePlace: AutocompletePlace;

  private subscriptions: Subscription = new Subscription();
  private _exchangeTripType: TripTypes;

  constructor(
    private facade: BaseSearchBarFacade,
    @Inject(IS_BROWSER) public isBrowser: boolean
  ) {
    super();
  }

  @HostListener('document:click', ['$event']) clickout(event: Event): void {
    if (this.isBrowser && !this.isMobile) {
      this.eventPath.next(event.composedPath());
      if (event['path']) {
        const inputButton = event['path'].find(paths =>
          !!paths['classList'] && paths['classList'].length > 0
          && paths['classList'].contains('travel-calendar-cont'));
        if ((!inputButton && this.showFlightOptionSelection) ||
          (inputButton && this.showCalendarInput && this.showFlightOptionSelection)) {
          this.toggleFlightOption();
        }
      }
    }
  }
  get exchangeTripType(): TripTypes {
    return this._exchangeTripType;
  }

  get showArrivalInput(): boolean {
    return this.exchangeTripType ?
      ((this.isOneWayTrip && this.exchangeTripType === TripTypes.RETURN) || !this.isOneWayTrip) : !this.isOneWayTrip;
  }

  get showDepartureInput(): boolean {
    return this.exchangeTripType ? this.exchangeTripType === TripTypes.DEPARTURE : true;
  }

  get arrivalPlace$(): Observable<AutocompletePlace> {
    return this.facade.arrivalPlace$;
  }

  get departurePlace$(): Observable<AutocompletePlace> {
    return this.facade.departurePlace$;
  }

  get showDesktopSearchOptions(): boolean {
    return !this.showCalendarInput && this.showFlightOptionSelection;
  }

  get isByHours(): boolean {
    return isByHours(this.searchType)
  }

  public toggleFlightOption(option?: string): void {
    this.showFlightOptionSelection = !this.showFlightOptionSelection;
    if (option) this.activeOption = option;
  }

  public flightTypeSelected(type: FlightType): void {
    if (this.isResultsPage && this.searchType === SearchType.HOME_FLIGHT) this.toggleFlightOption();
    this.selectFlightType.emit(type);
  }
}
